/******/ (() => { // webpackBootstrap
/* eslint-disable */
rimg.shopify.init('[data-rimg="lazy"]', {
  round: 1
});
const sections = new ShopifySectionsManager();
sections.register('age-gate', section => new AgeGate.PageAgeGate(section));
const ageGatePage = document.getElementById('age-gate-page');
if (ageGatePage) {
  new AgeGate.SiteAgeGate(ageGatePage);
}
document.addEventListener('DOMContentLoaded', function () {
  window.utils.enableDisclosure();
if (window.Flickity && window.Flickity.prototype && window.Flickity.prototype._create) {
  const oldFlickityCreate = window.Flickity.prototype._create;
  window.Flickity.prototype._create = function () {
    const that = this;
    if (this.element.addEventListener) {
      this.element.addEventListener('load', () => {
        that.onresize();
      }, true);
    }
    this._create = oldFlickityCreate;
    return oldFlickityCreate.apply(this, arguments);
  };
} else {
  console.warn('Flickity no está cargado');
}

  // Support for background images with new Lazysizes library
  document.addEventListener('lazyloaded', e => {
    let bg = e.target.getAttribute('data-bg');
    const mobileBg = e.target.getAttribute('data-mobile-bg');
    if (bg) {
      if (window.PXUTheme.media_queries.medium.matches && mobileBg) {
        bg = mobileBg;
      }
      e.target.style.backgroundImage = `url(${bg})`;
    }
  });

  // Call to flickity fix for sliders on IOS
  window.imageFunctions.flickityIosFix();
  window.header.init();
  window.mobileSearch.init();
  window.siteOverlay.init();
  window.meganavManager.injectAll();
  if (window.PXUTheme.theme_settings.enable_autocomplete) {
    window.predictiveSearch.init();
  }
  window.utils.initializeSectionWrapper();
  window.slideshow.init();
  window.testimonials.init();
  window.video.init();
  window.gallery.init();
  window.videoFeature.setupVideoPlayer();
  window.featuredPromotions.init();
  window.featuredCollection.init();
  window.logoList.init();
  window.collectionSidebarFilter.init();
  window.cart.init();
  window.map.init();
  window.shoppableImage.init();
  window.productPage.init();
  window.productPage.runOptionSelector();
  window.productPage.initializeQuantityBox();
  window.recentlyViewed.init();
  window.sidebarAccordions.init();
  if (window.PXUTheme.currency.show_multiple_currencies || window.PXUTheme.currency.native_multi_currency) {
    window.currencyConverter.init();
  }

  // Challenge page scroll

  // Return the pathname of the current URL
  const {
    pathname
  } = location;

  // If the pathname starts with '/challenge', animate scroll
  if (pathname.startsWith('/challenge')) {
    $('html, body').animate({
      scrollTop: 0
    }, 'slow');
  }

  // Setup a timer
  let resizeTimeout;
  // Grab screen width before screen is resized
  const beforeResizeWidth = $(window).width();

  // Listen for resize events
  window.addEventListener('resize', () => {
    // If timer is null, reset it to 66ms and run your functions.
    // Otherwise, wait until timer is cleared
    if (!resizeTimeout) {
      resizeTimeout = setTimeout(() => {
        // Reset timeout
        resizeTimeout = null;
        // Grab screen width after screen is resized
        const currentScreenWidth = $(window).width();
        // Run our resize functions
        if (window.PXUTheme.media_queries.medium.matches && currentScreenWidth !== beforeResizeWidth) {
          window.cart.init();
          if (!window.is_touch_device()) {
            if ($('.main-nav__wrapper.sticky_nav').length > 0) window.header.unload();
            window.header.init();
          }
        }
        window.logoList.init();

        // swap lazysizes background mobile images when browser is resized
        const lazysizesBackgroundImages = document.querySelectorAll('[data-bg]');
        lazysizesBackgroundImages.forEach(image => {
          let bg = image.getAttribute('data-bg');
          const mobileBg = image.getAttribute('data-mobile-bg');
          if (bg) {
            if (window.PXUTheme.media_queries.medium.matches && mobileBg) {
              bg = mobileBg;
            }
            image.style.backgroundImage = `url(${bg})`;
          }
        });
      }, 66);
    }
  }, false);

  // Lightbox default options
  // https://fancyapps.com/fancybox/3/docs/#options
  $.fancybox.defaults.animationEffect = 'fade';
  $.fancybox.defaults.transitionEffect = 'fade';
  $.fancybox.defaults.hash = false;
  $.fancybox.defaults.infobar = false;
  $.fancybox.defaults.toolbar = false;
  $.fancybox.defaults.arrows = false;
  $.fancybox.defaults.loop = true;
  $.fancybox.defaults.smallBtn = true;
  $.fancybox.defaults.live = false;
  $.fancybox.defaults.zoom = false;
  $.fancybox.defaults.mobile.preventCaptionOverlap = false;
  $.fancybox.defaults.mobile.toolbar = true;
  $.fancybox.defaults.mobile.buttons = ['close'];
  $.fancybox.defaults.mobile.clickSlide = 'close';
  $.fancybox.defaults.mobile.clickContent = 'zoom';
  $.fancybox.defaults.afterLoad = function (instance, slide) {
    if (instance.current.type === 'image') {
      slide.$content.wrapInner("<div class='fancybox-image-wrap'></div>");
    }
    if (instance.group.length > 1) {
      slide.$content.find('.fancybox-image-wrap').append(`<a title="Previous" class="fancybox-item fancybox-nav fancybox-prev" href="javascript:;" data-fancybox-prev><span>${window.svgArrowSizeLeft}</span></a><a title="Next" class="fancybox-item fancybox-nav fancybox-next" href="javascript:;" data-fancybox-next><span>${svgArrowSizeRight}</span></a>`);
    }
  };

  // backwards compatibility with custom lightboxes
  $('.lightbox[rel="gallery"]').fancybox();

  // Find youtube and vimeo iframes
  const $videoIframes = $('iframe[src*="youtube.com"], iframe[src*="vimeo.com"], iframe[src*="facebook.com/plugins/video"]');

  // For each iframe, if parent is a responsive video wrapper do nothing
  // If no parent responsive video wrapper, then wrap iframe in responsive video wrapper

  function getAspectRatio(width, height) {
    const ratio = width / height;

    // Determine ratio to be used
    if (Math.abs(ratio - 1 / 1) === 0) {
      return '1:1';
    }
    return Math.abs(ratio - 4 / 3) < Math.abs(ratio - 16 / 9) ? '4:3' : '16:9';
  }
  $videoIframes.each((_index, iframe) => {
    // Update selector
    const $iframe = $(iframe);

    // Grab src
    const source = $iframe.attr('src');
    if (!$iframe.parents('.plyr__video-wrapper').length && !$iframe.parents('.lazyframe').length) {
      $iframe.wrap(`<div class="lazyframe" data-ratio="${getAspectRatio($iframe.attr('width'), $iframe.attr('height'))}" data-src="${source}"></div>`);
    }
  });

  // Initiate lazyframe
  window.lazyframe('.lazyframe');

  // Wrap shopify policy in grid layout classes
  $('.shopify-policy__container').wrap('<section class="section shopify-policy-template"><div class="container content"></div>');

  // Add classes to determine column size
  $('.shopify-policy__container').addClass('five-eighths offset-by-three columns is-hidden-offset-mobile-only medium-down--one-whole');

  // Add featured divider beneath page title
  $('.shopify-policy__title').append('<div class="feature-divider"></div>');

  // Collection sorting

  const sortByEl = document.querySelector('[data-sort-by]');
  if (sortByEl) {
    sortByEl.addEventListener('change', e => {
      const {
        target
      } = e;
      const sortValue = target.value;
      if (target) {
        // Set the query string and redirect
        const queryString = new URLSearchParams(document.location.search);
        queryString.set('sort_by', sortValue);
        window.location.search = queryString;
      }
    });
  }
  $('body').on('change', '#tag_filter', () => {
    $('[data-option-filter] input').prop('checked', false);
    window.quickFilter.init();
  });
  $('body').on('change', '#blog_filter', function () {
    const url = $(this).val();
    window.location = url;
  });

  // Collection sidebar filter
  // Check the checkbox values
  $('body').on('change', '[data-option-filter] input', () => {
    window.quickFilter.init();
    $('html, body').animate({
      scrollTop: $('.content').offset().top
    }, 500);
  });
  $('body').on('click', '[data-reset-filters]', () => {
    window.collectionSidebarFilter.clearAllFilters();
  });
  $('body').on('click', '[data-clear-filter]', e => {
    const $this = $(e.currentTarget);
    const selectedOption = $this.parents('.filter-active-tag');
    window.collectionSidebarFilter.clearSelectedFilter(selectedOption);
  });
  $('body').on('change', '.currencies', () => {
    $('[data-initial-modal-price]').attr('data-initial-modal-price', '');
  });
  $('body').on('change', '.js-quick-shop select', () => {
    const currentVariant = $('.js-quick-shop select[name="id"]').val();
    if (currentVariant && window.globalQuickShopProduct) {
      window.quickShop.updateVariant(currentVariant);
    }
  });
  if (window.PXUTheme.theme_settings.quick_shop_enabled) {
    window.quickShop.init();
  }
  let touchStartPos = 0;

  // Detecting swipe vs tap
  $(document).bind('touchstart', () => {
    touchStartPos = $(window).scrollTop();
  }).bind('touchend', e => {
    const distance = touchStartPos - $(window).scrollTop();
    if (distance > 20 || distance < -20) {
      e.preventDefault;
    }
  });
  $('body').on('click', '.sidebar .parent-link--false', function (e) {
    e.preventDefault();
    const $menu = $(this).parent('li');
    $menu.find('.menu-toggle').toggleClass('active');
    $menu.find('ul').slideToggle();
  });
  if (window.PXUTheme.theme_settings.newsletter_popup) {
    window.newsletter_popup.init();
  }
  if (window.PXUTheme.theme_settings.enable_back_to_top_button) {
    window.back_to_top_button.init();
  }
  if (window.location.pathname.indexOf('/comments') !== -1) {
    $('html,body').animate({
      scrollTop: $('#new-comment').offset().top - 140
    }, 'slow');
  }
  if (window.PXUTheme.media_queries.large.matches) {
    $('.animate_right').waypoint(function () {
      $(this.element).addClass('animated fadeInRight');
    }, {
      offset: '70%'
    });
    $('.animate_left').waypoint(function () {
      $(this.element).addClass('animated fadeInLeft');
    }, {
      offset: '70%'
    });
    $('.animate_up').waypoint(function () {
      $(this.element).addClass('animated fadeInUp');
    }, {
      offset: '70%'
    });
    $('.animate_down').waypoint(function () {
      $(this.element).addClass('animated fadeInDown');
    }, {
      offset: '70%'
    });
  }

  // backwards compatibility with flexslider
  $('.slider, .flexslider').find('li').unwrap();
  $('.slider, .flexslider').flickity({
    pageDots: window.usePageDots,
    imagesLoaded: true,
    arrowShape: window.arrowSize,
    lazyLoad: 2
  });
  window.utils.createAccordion('.footer_menu', 'h6', 'ul');
  window.utils.createAccordion('.footer_content', 'h6', 'div.toggle_content');
  window.utils.createAccordion('.product_section .accordion-tabs', '.tabs li > a', '.tabs-content li');
  window.utils.mobileParentActiveAccordion('#mobile_menu', 'li.sublink > a.parent-link--true span');
  window.utils.mobileAccordion('#mobile_menu', 'li.sublink > a');
  window.utils.initializeTabs();
  window.accordion.init();
  $('body').on('click', '.menu-toggle', function () {
    const $content = $(this).next('ul');
    $content.slideToggle();
    $(this).toggleClass('active');
    $(this).attr('aria-expanded', $(this).attr('aria-expanded') === 'true' ? 'false' : 'true');
  });
  if (window.PXUTheme.theme_settings.collection_swatches) {
    if (window.PXUTheme.media_queries.large.matches) {
      $('body').on('mouseenter', '.collection_swatches', function () {
        $('.swatch span', $(this)).each(function () {
          if ($(this).data('image').indexOf('no-image') === -1) {
            $('<img/>')[0].src = $(this).data('image');
          }
        });
      });
      $('body').on('mouseenter', '.swatch span', function () {
        if ($(this).data('image').indexOf('no-image') === -1) {
          $(this).parents('.thumbnail').find('.image__container img:not(.secondary)').attr('src', $(this).data('image'));
          $(this).parents('.thumbnail').find('.image__container img:not(.secondary)').attr('srcset', $(this).data('image'));
        }
      });
    }
  }

  // Terms of service settings for minicart
  if (window.PXUTheme.theme_settings.display_tos_checkbox) {
    $('body').on('click touchstart', '.cart_content .tos_label', function () {
      $(this).prev('input').prop('checked', true);
    });
  }
  if (window.PXUTheme.theme_settings.display_tos_checkbox && window.PXUTheme.theme_settings.go_to_checkout) {
    // Terms of service on mini-cart && cart page
    $('body').on('click', '.tos_warning [data-cart-checkout-button]', function (e) {
      if ($(this).parents('form').find('.tos_agree').is(':checked')) {
        // Check if we are on the cart page or mini cart
        if (window.PXUTheme.theme_settings.go_to_checkout || $('body').hasClass('cart')) {
          $(this).submit();
        } else {
          // Redirect to cart page
          e.preventDefault();
          document.location.href = window.PXUTheme.routes.cart_url;
        }
      } else {
        const warning = `<p class="warning animated bounceIn">${window.PXUTheme.translation.agree_to_terms_warning}</p>`;
        if ($('p.warning').length === 0) {
          $(this).before(warning);
        }
        return false;
      }
    });
  } else if (!window.PXUTheme.theme_settings.go_to_checkout) {
    $('body').on('click', '.cart_content [data-minicart-checkout-button]', e => {
      // Redirect to cart page
      e.preventDefault();
      document.location.href = window.PXUTheme.routes.cart_url;
    });
  }
  if (window.PXUTheme.theme_settings.collection_secondary_image) {
    window.imageFunctions.showSecondaryImage();
  }

  // Contact form checkbox validation
  if ($('[data-is-required]').length) {
    const $checkboxGroup = $('.custom-contact__checkbox');
    $checkboxGroup.prop('required', true);
    $checkboxGroup.on('change', () => {
      $checkboxGroup.prop('required', true);
      if ($checkboxGroup.is(':checked')) {
        $checkboxGroup.prop('required', false);
      }
    });
  }
  $('.maps').click(() => {
    $('.maps iframe').css('pointer-events', 'auto');
  });

  // Load more / infinite load

  if (window.PXUTheme.theme_settings.pagination_type === 'load_more') {
    window.enableLoadMoreProducts();
  }
  if (window.PXUTheme.theme_settings.pagination_type === 'load_more_button') {
    window.enableLoadMoreButton('[data-product-list]');
  }
  if (window.PXUTheme.theme_settings.pagination_type === 'infinite_scroll') {
    window.enableInfiniteScroll('[data-product-list]');
  }

  /*= ===========================================================================
    Start of cart-related functionality
  ============================================================================== */

  const CART_MUTATION_TIMEOUT = 10000;
  let cartQuantityPending = false;
  const CART_MUTATION_FALLBACK_MESSAGE = 'No pudimos completar el cambio en tu carrito. Revisa tu conexión e inténtalo nuevamente.';
  function parseCartMutationError(XMLHttpRequest) {
    if (!XMLHttpRequest || typeof XMLHttpRequest.responseText !== 'string' || XMLHttpRequest.responseText.trim() === '') {
      return null;
    }
    try {
      const response = JSON.parse(XMLHttpRequest.responseText);
      return response && typeof response === 'object' && !Array.isArray(response) ? response : null;
    } catch (_error) {
      return null;
    }
  }
  function resolveCartMutationError(XMLHttpRequest) {
    const response = parseCartMutationError(XMLHttpRequest);
    const hasShopifyDescription = response && typeof response.description === 'string' && response.description.trim() !== '';
    return {
      response,
      message: hasShopifyDescription ? response.description.trim() : CART_MUTATION_FALLBACK_MESSAGE
    };
  }
  function announceCartMutationError(message) {
    const $liveRegion = $('[data-cart-live-region]').first();
    if (!$liveRegion.length) {
      return false;
    }
    $liveRegion.text(message);
    return true;
  }
  function renderCartMutationError($target, message) {
    $('.warning--cart-mutation').remove();
    const $warning = $('<p>', {
      class: 'warning warning--cart-mutation animated bounceIn'
    }).text(message);
    if (!announceCartMutationError(message)) {
      $warning.attr({
        role: 'status',
        'aria-live': 'polite',
        'aria-atomic': 'true'
      });
    }
    if ($target && $target.length) {
      $target.after($warning);
    } else {
      $('[data-cart-form]').first().before($warning);
    }
  }
  function requestCartMutation(ajaxOptions, recovery) {
    const recoveryCallbacks = recovery || {};
    return $.ajax($.extend({}, ajaxOptions, {
      timeout: CART_MUTATION_TIMEOUT,
      error(XMLHttpRequest, textStatus, errorThrown) {
        if (typeof recoveryCallbacks.error === 'function') {
          recoveryCallbacks.error(resolveCartMutationError(XMLHttpRequest), XMLHttpRequest, textStatus, errorThrown);
        }
      },
      complete(XMLHttpRequest, textStatus) {
        if (typeof recoveryCallbacks.complete === 'function') {
          recoveryCallbacks.complete(XMLHttpRequest, textStatus);
        }
      }
    }));
  }
  function confirmedCartInputValue($input) {
    if (!$input || !$input.length) {
      return '';
    }
    const input = $input[0];
    return typeof input.defaultValue === 'string' ? input.defaultValue : $input.val();
  }
  function commitCartInputValue($input, quantity) {
    const value = String(quantity);
    $input.val(value);
    $input.each((_index, input) => {
      input.defaultValue = value;
    });
  }
  function setCartItemControlsBusy(cartItem, isBusy) {
    cartItem.$element.find('.js-change-quantity').prop('disabled', isBusy).toggleClass('is-disabled', isBusy);
    cartItem.$input.prop('readOnly', isBusy);
    const $removeButton = cartItem.$element.find('[data-remove-item]');
    $removeButton.toggleClass('is-disabled', isBusy);
    if (isBusy) {
      $removeButton.attr('aria-disabled', 'true');
    } else {
      $removeButton.removeAttr('aria-disabled');
    }
  }
  function restoreCartItemState(cartItem) {
    cartItem.$input.val(cartItem.confirmedQuantity);
    if (cartItem.operation === 'remove') {
      cartItem.$element.removeClass('animated fadeOutLeft');
    }
  }
  function releaseAddToCartButton($addToCartBtn, requestSucceeded, labelBeforeRequest) {
    $addToCartBtn.prop('disabled', false).removeAttr('disabled').removeClass('disabled');
    $addToCartBtn.find('.checkmark').removeClass('checkmark-active');
    const $label = $addToCartBtn.find('.text').first();
    $label.removeClass('zoomOut');
    if (requestSucceeded) {
      $label.removeClass('zoomIn').addClass('fadeInDown');
    } else {
      $label.text(labelBeforeRequest).removeClass('fadeInDown').addClass('zoomIn');
    }
  }
  function ajaxSubmitCart(cart) {
    const $cart = cart;
    $.ajax({
      url: '/cart/update.js',
      dataType: 'json',
      cache: false,
      type: 'post',
      data: $cart.serialize(),
      success(data) {
        refreshCart(data);
      }
    });
  }
  function updateCartItemQuantity(cartItem) {
    const changeData = {
      quantity: cartItem.quantity,
      id: cartItem.key
    };
    if (cartItem.parentCartForm.data('cart-form') === 'mini-cart') {
      changeData.sections = 'header';
      changeData.sections_url = window.location.pathname;
    }
    requestCartMutation({
      url: '/cart/change.js',
      dataType: 'json',
      cache: false,
      type: 'post',
      data: changeData,
      success(data) {
        // A successful mutation always refreshes prices, keys and quantities.
        // A removed line's old index can now belong to a different product.
        if (cartItem.parentCartForm.data('cart-form') === 'cart-template' || document.querySelector('[data-cart-form="cart-template"]')) {
          cartItem.navigationPending = true;
          window.location.reload();
        } else {
          refreshCart(data);
          const updatedItem = data.items.find(item => item.key === cartItem.key);
          if (updatedItem && updatedItem.quantity < cartItem.quantity) {
            const itemsLeftText = updatedItem.quantity === 1 ? window.PXUTheme.translation.one_item_left : window.PXUTheme.translation.items_left_text;
            renderCartMutationError(cartItem.parentCartForm, `${updatedItem.quantity} ${itemsLeftText}`);
          }
        }
      }
    }, {
      error(errorState) {
        document.dispatchEvent(new CustomEvent('chagual:cart-change-failed'));
        restoreCartItemState(cartItem);
        renderCartMutationError(cartItem.$element.find('.product-quantity-box').first(), errorState.message);
      },
      complete() {
        setCartItemControlsBusy(cartItem, false);
        cartQuantityPending = Boolean(cartItem.navigationPending);
      }
    });
  }
  function isCartAdvancePurchaseProperty(title) {
    return [
      'Compra anticipada',
      'Despacho estimado',
      'Nota despacho'
    ].includes(title);
  }
  function renderCartAdvancePurchase(properties) {
    if (!properties || properties['Compra anticipada'] !== 'Sí') {
      return '';
    }
    const estimatedDelivery = properties['Despacho estimado'];
    const shippingNote = properties['Nota despacho'];
    let advancePurchaseHTML = '<div class="chagual-cart-advance-purchase" data-cart-advance-purchase>';
    advancePurchaseHTML += '<p class="chagual-cart-advance-purchase__title">Compra anticipada</p>';
    if (estimatedDelivery && String(estimatedDelivery).trim() !== '') {
      advancePurchaseHTML += `<p class="chagual-cart-advance-purchase__detail"><strong>Despacho estimado:</strong> ${htmlEncode(estimatedDelivery)}</p>`;
    }
    if (shippingNote && String(shippingNote).trim() !== '') {
      advancePurchaseHTML += `<p class="chagual-cart-advance-purchase__detail"><strong>Nota despacho:</strong> ${htmlEncode(shippingNote)}</p>`;
    }
    advancePurchaseHTML += '</div>';
    return advancePurchaseHTML;
  }
  function resolveCartLinePrice(item) {
    const parsedFinalPrice = Number(item.final_price);
    const finalPrice = Number.isFinite(parsedFinalPrice) && parsedFinalPrice >= 0 ? parsedFinalPrice : 0;
    const previousPriceCandidates = [
      item.original_price,
      item.selling_plan_allocation && item.selling_plan_allocation.compare_at_price
    ];
    let previousPrice = null;
    previousPriceCandidates.forEach(candidate => {
      const parsedCandidate = Number(candidate);
      if (Number.isFinite(parsedCandidate) && parsedCandidate > finalPrice && (previousPrice === null || parsedCandidate > previousPrice)) {
        previousPrice = parsedCandidate;
      }
    });
    return {
      finalPrice,
      previousPrice
    };
  }
  function getRenderedHeaderHTML(cart) {
    if (!cart || !cart.sections || typeof cart.sections.header !== 'string') {
      return '';
    }
    return cart.sections.header;
  }
  function syncMiniCartInstances(renderedHeaderRoot) {
    if (!renderedHeaderRoot) {
      return false;
    }
    const renderedEmptyMessage = renderedHeaderRoot.querySelector('.js-empty-cart__message');
    const renderedForm = renderedHeaderRoot.querySelector('[data-cart-form="mini-cart"]');
    const currentEmptyMessages = document.querySelectorAll('.js-empty-cart__message');
    const currentForms = document.querySelectorAll('[data-cart-form="mini-cart"]');
    if (!renderedEmptyMessage || !renderedForm || !currentEmptyMessages.length || !currentForms.length) {
      return false;
    }
    currentEmptyMessages.forEach(currentEmptyMessage => {
      currentEmptyMessage.classList.toggle('hidden', renderedEmptyMessage.classList.contains('hidden'));
    });
    const renderedSelectors = [
      '.js-cart_items',
      '.js-cart_discounts',
      '.js-cart_subtotal',
      '.js-cart_savings'
    ];
    currentForms.forEach(currentForm => {
      currentForm.classList.toggle('hidden', renderedForm.classList.contains('hidden'));
      renderedSelectors.forEach(selector => {
        const renderedTarget = renderedForm.querySelector(selector);
        const currentTarget = currentForm.querySelector(selector);
        if (renderedTarget && currentTarget) {
          currentTarget.innerHTML = renderedTarget.innerHTML;
        }
      });
      const renderedP08Notice = renderedForm.querySelector('[data-cart-p08-packaging-notice]');
      const currentP08Notice = currentForm.querySelector('[data-cart-p08-packaging-notice]');
      if (renderedP08Notice && currentP08Notice) {
        currentP08Notice.innerHTML = renderedP08Notice.innerHTML;
        currentP08Notice.toggleAttribute('hidden', renderedP08Notice.hasAttribute('hidden'));
      }
      currentForm.setAttribute('data-total-discount', renderedForm.getAttribute('data-total-discount'));
    });
    const renderedCartCount = renderedHeaderRoot.querySelector('.cart_count');
    if (renderedCartCount) {
      const renderedItemCount = parseInt(renderedCartCount.textContent, 10);
      if (Number.isFinite(renderedItemCount)) {
        document.querySelectorAll('.cart_count').forEach(currentCartCount => {
          currentCartCount.textContent = renderedItemCount;
        });
        document.querySelectorAll('.mini_cart').forEach(currentMiniCart => {
          currentMiniCart.setAttribute('aria-label', renderedItemCount === 1 ? 'Ver carrito, 1 producto' : `Ver carrito, ${renderedItemCount} productos`);
        });
      }
    }
    return true;
  }
  function refreshMiniCartFromRenderedHeader(cart) {
    const renderedHeaderHTML = getRenderedHeaderHTML(cart);
    if (!renderedHeaderHTML) {
      return false;
    }
    const $renderedHeader = $('<div>').append($.parseHTML(renderedHeaderHTML, document, true));
    return syncMiniCartInstances($renderedHeader[0]);
  }
  function refreshCart(cart) {
    $('.cart_count').empty();
    const $cartBtn = $('.cart_count');
    const value = $cartBtn.text() || '0';
    let cartItemsHTML = '';
    let cartDiscountsHTML = '';
    let cartActionHTML = '';
    let cartSavingsHTML = '';
    const $cartForm = $('[data-cart-form]');
    $cartForm.data('total-discount', cart.total_discount);
    $cartBtn.text(value.replace(/[0-9]+/, cart.item_count));
    $('.mini_cart').attr('aria-label', cart.item_count === 1 ? 'Ver carrito, 1 producto' : `Ver carrito, ${cart.item_count} productos`);
    if (refreshMiniCartFromRenderedHeader(cart)) {
      if (window.PXUTheme.currency.show_multiple_currencies) {
        window.currencyConverter.convertCurrencies();
      }
      return;
    }
    if (cart.item_count === 0) {
      $('.js-empty-cart__message').removeClass('hidden');
      $cartForm.addClass('hidden');
    } else {
      $('.js-empty-cart__message').addClass('hidden');
      $cartForm.removeClass('hidden');
      let totalSaving = 0; // adding counter variables for total cart savings
      let representedDiscountTotal = 0;
      $.each(cart.items, (index, item) => {
        const itemDiscounts = item.discounts;
        let discountMessage = '';
        for (let i = 0; i < itemDiscounts.length; i++) {
          const {
            title
          } = itemDiscounts[i];
          discountMessage = `<p class="notification-discount meta">${title}</p>`;
        }
        const lineID = index + 1;
        const cartKeyAttribute = htmlEncode(item.key).replace(/"/g, '&quot;');
        cartItemsHTML += `<li class="mini-cart__item" data-cart-item data-cart-key="${cartKeyAttribute}" data-line-id="${lineID}" data-variant-id="${item.id}">` + `<a href="${item.url}">`;
        if (item.image) {
          cartItemsHTML += `${'<div class="cart_image">' + '<img src="'}${item.image.replace(/(\.[^.]*)$/, '_compact$1').replace('http:', '')}" alt="${htmlEncode(item.title)}" />` + '</div></a>';
        }
        cartItemsHTML += `<div class="mini-cart__item-content"><div class="mini-cart__item-title"><a href="${item.url}">${item.title}</a>`;
        if (item.selling_plan_allocation) {
          cartItemsHTML += `<div class="meta">${item.selling_plan_allocation.selling_plan.name}</div>`;
        }
        cartItemsHTML += renderCartAdvancePurchase(item.properties);
        let genericPropertiesHTML = '';
        if (item.properties) {
          $.each(item.properties, (title, value) => {
            if (value && value !== 'on' && !isCartAdvancePurchaseProperty(title)) {
              genericPropertiesHTML += `<div class="mini-cart__item-property">${htmlEncode(title)}: ${htmlEncode(value)}</div>`;
            }
          });
        }
        if (genericPropertiesHTML) {
          cartItemsHTML += `<div class="mini-cart__item-properties">${genericPropertiesHTML}</div>`;
        }
        cartItemsHTML += '</div><div class="mini-cart__item-price">';
        const linePriceState = resolveCartLinePrice(item);
        if (linePriceState.finalPrice > 0) {
          const finalPrice = window.Shopify.formatMoney(linePriceState.finalPrice, $('body').data('money-format'));
          cartItemsHTML += `<span class="money${linePriceState.previousPrice !== null ? ' sale' : ''}">${finalPrice}</span>`;
        } else {
          cartItemsHTML += `<span>${window.PXUTheme.translation.cart_free_text}</span>`;
        }
        if (linePriceState.previousPrice !== null) {
          cartItemsHTML += `<span class="money was_price">${window.Shopify.formatMoney(linePriceState.previousPrice, $('body').data('money-format'))}</span>`;
          totalSaving += (linePriceState.previousPrice - linePriceState.finalPrice) * item.quantity;
        }
        const originalPrice = Number(item.original_price);
        if (Number.isFinite(originalPrice) && originalPrice > linePriceState.finalPrice) {
          representedDiscountTotal += (originalPrice - linePriceState.finalPrice) * item.quantity;
        }
        cartItemsHTML += '</div>';

        // Unit price

        if (item.unit_price_measurement && item.price > 0) {
          let unitPriceMeasurementReferenceValue = '';
          if (item.unit_price_measurement.reference_value !== 1) {
            unitPriceMeasurementReferenceValue = item.unit_price_measurement.reference_value;
          }
          cartItemsHTML += `<p class="mini-cart__unit-price">${item.unit_price_measurement.quantity_value}${item.unit_price_measurement.quantity_unit} | ${Shopify.formatMoney(item.unit_price, $('body').data('money-format'))} / ${unitPriceMeasurementReferenceValue}${item.unit_price_measurement.reference_unit}</p>`;
        }
        if (itemDiscounts.length > 0) {
          cartItemsHTML += discountMessage;
        }
        // B5 de la auditoria 22 — el mini-carrito regenera este mismo marcado y aqui
        // el boton de eliminar no tiene NINGUN texto: solo un icono. Sin nombre
        // accesible, el lector anunciaba "enlace" a secas, una vez por linea. El
        // titulo de la linea ya incluye la variante, asi que distingue dos tallas
        // del mismo producto. htmlEncode no escapa la comilla doble y aqui el valor
        // va dentro de un atributo, asi que se escapa tambien.
        const tituloAtributo = htmlEncode(item.title).replace(/"/g, '&quot;');
        cartItemsHTML += '<div class="product-quantity-box">';
        cartItemsHTML += `<button type="button" class="ss-icon product-minus js-change-quantity" data-func="minus" aria-label="Disminuir cantidad de ${tituloAtributo}"><span class="icon-minus" aria-hidden="true"></span></button>`;
        cartItemsHTML += `<input type="number" min="0" class="quantity" name="updates[${cartKeyAttribute}]" id="updates_${cartKeyAttribute}" value="${item.quantity}" aria-label="Cantidad de ${tituloAtributo}" data-cart-quantity-input="mini-cart" />`;
        cartItemsHTML += `<button type="button" class="ss-icon product-plus js-change-quantity" data-func="plus" aria-label="Aumentar cantidad de ${tituloAtributo}"><span class="icon-plus" aria-hidden="true"></span></button>`;
        cartItemsHTML += '</div></div></div>';
        cartItemsHTML += `<a href="/cart/change?id=${encodeURIComponent(item.key)}&amp;quantity=0" class="js-cart-remove-btn cart__remove-btn" aria-label="Eliminar ${tituloAtributo} del carrito" data-line-id="${lineID}" data-remove-item="mini-cart"><span class="remove-icon" aria-hidden="true"></span></a>`;
      });
      const cartDiscounts = cart.cart_level_discount_applications;
      for (let i = 0; i < cartDiscounts.length; i++) {
        const amount = window.Shopify.formatMoney(cartDiscounts[i].total_allocated_amount, $('body').data('money-format'));
        const {
          title
        } = cartDiscounts[i];
        cartDiscountsHTML += `<span class="cart_discounts--title">${title}</span>`;
        cartDiscountsHTML += '<span class="cart_discounts--price">';
        cartDiscountsHTML += `-<span class="money">${amount}</span></span>`;
      }
      cartActionHTML += `<span class="right"><span class="money">${window.Shopify.formatMoney(cart.total_price, $('body').data('money-format'))}</span></span> <span>${window.PXUTheme.translation.cart_subtotal_text}</span>`;
      totalSaving += Math.max(cart.total_discount - representedDiscountTotal, 0);
      if (window.PXUTheme.theme_settings.display_savings && totalSaving > 0) {
        cartSavingsHTML = `<span class="right"><span class="money">${window.Shopify.formatMoney(totalSaving, $('body').data('money-format'))}</span></span>` + `<span>${window.PXUTheme.translation.cart_savings_text}</span>`;
      } else {
        cartSavingsHTML = '';
      }
    }
    $('.js-cart_items').html(cartItemsHTML);
    $('.js-cart_discounts').html(cartDiscountsHTML);
    $('.js-cart_subtotal').html(cartActionHTML);
    $('.js-cart_savings').html(cartSavingsHTML);

    // Converting the currencies
    if (window.PXUTheme.currency.show_multiple_currencies) {
      window.currencyConverter.convertCurrencies();
    }
  }
  function changeCartQuantity() {
    const $input = $(this);
    const $cartItem = $input.parents('[data-cart-item]');
    const confirmedQuantity = confirmedCartInputValue($input);
    if (cartQuantityPending) {
      if (!$input.prop('readOnly')) $input.val(confirmedQuantity);
      return;
    }
    const quantityText = $input.val().trim();
    if (quantityText === confirmedQuantity) return;
    const quantity = Number(quantityText);
    const key = $cartItem.attr('data-cart-key');
    if (!key || quantityText === '' || !Number.isSafeInteger(quantity) || quantity < 0) {
      $input.val(confirmedQuantity);
      renderCartMutationError($cartItem, CART_MUTATION_FALLBACK_MESSAGE);
      return;
    }
    const cartItem = {
      key,
      variantID: $cartItem.data('variant-id'),
      quantity,
      parentCartForm: $input.parents('[data-cart-form]'),
      totalDiscount: $input.parents('[data-cart-form]').data('total-discount'),
      $element: $cartItem,
      $input,
      confirmedQuantity,
      operation: 'change'
    };
    cartQuantityPending = true;
    setCartItemControlsBusy(cartItem, true);
    updateCartItemQuantity(cartItem);
  }
  $('body').on('change', '[data-cart-quantity-input]', changeCartQuantity);
  // Mobile keyboards can commit on blur; the pending/default-value guards
  // coalesce change + focusout into one request, including a literal zero.
  $('body').on('focusout', '[data-cart-quantity-input]', changeCartQuantity);
  $('body').on('click', '[data-remove-item]', function (e) {
    e.preventDefault();
    const $removeButton = $(this);
    if ($removeButton.hasClass('is-disabled')) {
      return;
    }
    if (cartQuantityPending) return;
    const $cartItem = $removeButton.parents('[data-cart-item]');
    const $input = $cartItem.find('[data-cart-quantity-input]').first();
    const $parentCartForm = $removeButton.parents('[data-cart-form]');
    const key = $cartItem.attr('data-cart-key');
    if (!key) {
      renderCartMutationError($cartItem, CART_MUTATION_FALLBACK_MESSAGE);
      return;
    }
    const cartItem = {
      key,
      variantID: $cartItem.data('variant-id'),
      quantity: 0,
      parentCartForm: $parentCartForm,
      totalDiscount: $parentCartForm.data('total-discount'),
      $element: $cartItem,
      $input,
      confirmedQuantity: confirmedCartInputValue($input),
      operation: 'remove'
    };
    cartItem.$element.addClass('animated fadeOutLeft');
    cartItem.$input.val('0');
    cartQuantityPending = true;
    setCartItemControlsBusy(cartItem, true);
    updateCartItemQuantity(cartItem);
  });
  function showMobileCartConfirmation() {
    if (window.PXUTheme.media_queries.large.matches) {
      return;
    }
    const confirmation = document.querySelector('[data-cart-mobile-confirmation]');
    if (confirmation) {
      confirmation.hidden = false;
    }
  }
  function hideMobileCartConfirmation() {
    const confirmation = document.querySelector('[data-cart-mobile-confirmation]');
    if (confirmation) {
      confirmation.hidden = true;
    }
  }
  $('body').on('click', '[data-cart-mobile-confirmation-close]', function () {
    hideMobileCartConfirmation();
  });
  if (window.PXUTheme.theme_settings.cart_action === 'ajax') {
    $(document).on('click', '.ajax-submit', function (e) {
      e.preventDefault();
      const $addToCartForm = $(this).closest('form');
      if ($('body').hasClass('cart')) {
        $addToCartForm.submit();
        return false;
      }
      const $addToCartBtn = $addToCartForm.find('.add_to_cart');
      const addToCartLabelBeforeRequest = $addToCartBtn.find('.text').first().text();
      const addData = $addToCartForm.serializeArray();
      addData.push({
        name: 'sections',
        value: 'header'
      });
      addData.push({
        name: 'sections_url',
        value: window.location.pathname
      });
      const recipientForm = $addToCartForm[0].querySelector('[data-recipient-form]');
      let addRequestSucceeded = false;
      $('.warning').remove();
      if (recipientForm) {
        recipientForm.classList.remove('recipient-form--has-errors');
      }

      requestCartMutation({
        url: '/cart/add.js',
        dataType: 'json',
        cache: false,
        type: 'post',
        data: addData,
        beforeSend() {
          hideMobileCartConfirmation();
          $addToCartBtn.attr('disabled', 'disabled').addClass('disabled');
          $addToCartBtn.find('span').removeClass('fadeInDown').addClass('animated zoomOut');
        },
        success(addResponse) {
          addRequestSucceeded = true;
          $addToCartBtn.find('.checkmark').addClass('checkmark-active');
          setTimeout(function () {
            const miniCartUpdated = refreshMiniCartFromRenderedHeader(addResponse);
            if (!miniCartUpdated) {
              renderCartMutationError($addToCartForm, 'El producto ya fue agregado. Abrimos tu carrito para mostrarlo.');
              window.location.assign((window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + 'cart');
              return;
            }
            if ($('body').hasClass('fancybox-active')) {
              $.fancybox.close();
            }
            const supportsMiniCart = window.PXUTheme.media_queries.large.matches && !window.is_touch_device();
            if (supportsMiniCart) {
              let $autoOpenedCartContainer;
              if ($('.sticky_nav--stick').length) {
                $autoOpenedCartContainer = $('.sticky_nav .cart-container');
              } else {
                $autoOpenedCartContainer = $('[data-desktop-header] .top-bar .cart-container');
              }
              $autoOpenedCartContainer.addClass('active_link');
              if (window.header && typeof window.header.clampMiniCartToViewport === 'function') {
                window.header.clampMiniCartToViewport($autoOpenedCartContainer);
              }
            } else {
              $('.cart-container').removeClass('active_link');
              $('body').removeClass('blocked-scroll');
              if (miniCartUpdated) {
                showMobileCartConfirmation();
              }
            }
          }, 500);
        }
      }, {
        error(errorState) {
          hideMobileCartConfirmation();
          if (recipientForm && errorState.response && errorState.response.errors && errorState.response.errors.email) {
            recipientForm.classList.add('recipient-form--has-errors');
          }
          renderCartMutationError($addToCartForm, errorState.message);
        },
        complete() {
          if (addRequestSucceeded) {
            window.setTimeout(() => {
              releaseAddToCartButton($addToCartBtn, true, addToCartLabelBeforeRequest);
            }, 1000);
          } else {
            releaseAddToCartButton($addToCartBtn, false, addToCartLabelBeforeRequest);
          }
        }
      });
      return false;
    });
  }
  window.productPage.productSwatches();
  window.Shopify.initializeSwatchAccessibleNames();
});

/*= ===========================================================================
  Swatch options - second and third swatch 'sold-out' will update based on availability of previous options selected
============================================================================== */
// CHAGUAL_PDP_SWATCH_ARIA_START
window.Shopify.resolveSwatchAccessibleState = function (product, selectedOptions, selectorIndex, candidateValue) {
  const candidateOptions = selectedOptions.slice(0, product.options.length);
  candidateOptions[selectorIndex] = candidateValue;
  const exactVariant = product.variants.find(variant => {
    const variantOptions = variant.options || [variant.option1, variant.option2, variant.option3].slice(0, product.options.length);
    return variantOptions.length === candidateOptions.length && variantOptions.every((value, index) => value === candidateOptions[index]);
  });
  if (!exactVariant) return 'nonexistent';
  return exactVariant.available === false ? 'soldout' : 'available';
};
window.Shopify.updateSwatchAccessibleNames = function (product, parent) {
  const productSection = typeof parent === 'string' ? document.querySelector(parent) : parent;
  if (!productSection) return;
  const selectors = productSection.querySelectorAll('.single-option-selector');
  const selectedOptions = Array.prototype.map.call(selectors, selector => selector.value);
  const radios = productSection.querySelectorAll('.swatch[data-option-index] input[type="radio"]');
  Array.prototype.forEach.call(radios, radio => {
    const swatch = radio.closest('.swatch[data-option-index]');
    const selectorIndex = Number(swatch.getAttribute('data-option-index'));
    const state = window.Shopify.resolveSwatchAccessibleState(product, selectedOptions, selectorIndex, radio.value);
    const baseName = radio.getAttribute('data-aria-label-base');
    const soldOutName = radio.getAttribute('data-aria-label-sold-out');
    radio.setAttribute('aria-label', state === 'soldout' ? soldOutName : baseName);
  });
};
window.Shopify.initializeSwatchAccessibleNames = function () {
  const productForms = document.querySelectorAll('.js-product-section .product_form');
  Array.prototype.forEach.call(productForms, productForm => {
    const product = $(productForm).data('product');
    const productSection = productForm.closest('.js-product-section');
    if (product && productSection) window.Shopify.updateSwatchAccessibleNames(product, productSection);
  });
};
// CHAGUAL_PDP_SWATCH_ARIA_END
window.Shopify.updateOptionsInSelector = function (selectorIndex, parent, product) {
  switch (selectorIndex) {
    case 0:
      var key = 'root';
      break;
    case 1:
      var key = $(`${parent} .single-option-selector:eq(0)`).val();
      break;
    case 2:
      var key = $(`${parent} .single-option-selector:eq(0)`).val();
      key += ` / ${$(`${parent} .single-option-selector:eq(1)`).val()}`;
  }
  const availableOptions = Shopify.optionsMap[key];
  $(`${parent} .swatch[data-option-index="${selectorIndex}"] .swatch-element`).each(function () {
    if ($.inArray($(this).attr('data-value'), availableOptions) !== -1) {
      $(this).removeClass('soldout').find(':radio').removeAttr('disabled', 'disabled').removeAttr('checked');
    } else {
      $(this).addClass('soldout').find(':radio').removeAttr('checked').attr('disabled', 'disabled');
    }
  });
  window.Shopify.updateSwatchAccessibleNames(product, parent);
};
window.Shopify.linkOptionSelectors = function (product, parent) {
  // Building our mapping object.
  window.Shopify.optionsMap = {};
  for (let i = 0; i < product.variants.length; i++) {
    const variant = product.variants[i];
    // Include sold-out variants so shoppers can select them and see real sold-out state.
    window.Shopify.optionsMap.root = window.Shopify.optionsMap.root || [];
    window.Shopify.optionsMap.root.push(variant.option1);
    window.Shopify.optionsMap.root = window.Shopify.uniq(window.Shopify.optionsMap.root);
    // Gathering values for the 2nd drop-down.
    if (product.options.length > 1) {
      const key = variant.option1;
      window.Shopify.optionsMap[key] = window.Shopify.optionsMap[key] || [];
      window.Shopify.optionsMap[key].push(variant.option2);
      window.Shopify.optionsMap[key] = window.Shopify.uniq(window.Shopify.optionsMap[key]);
    }
    // Gathering values for the 3rd drop-down.
    if (product.options.length === 3) {
      const key = `${variant.option1} / ${variant.option2}`;
      window.Shopify.optionsMap[key] = window.Shopify.optionsMap[key] || [];
      window.Shopify.optionsMap[key].push(variant.option3);
      window.Shopify.optionsMap[key] = window.Shopify.uniq(window.Shopify.optionsMap[key]);
    }
  }
  // Update options right away.
  window.Shopify.updateOptionsInSelector(0, parent, product);
  if (product.options.length > 1) window.Shopify.updateOptionsInSelector(1, parent, product);
  if (product.options.length === 3) window.Shopify.updateOptionsInSelector(2, parent, product);
  // When there is an update in the first dropdown.
  $(`${parent} .single-option-selector:eq(0)`).change(() => {
    window.Shopify.updateOptionsInSelector(1, parent, product);
    if (product.options.length === 3) window.Shopify.updateOptionsInSelector(2, parent, product);
    return true;
  });
  // When there is an update in the second dropdown.
  $(`${parent} .single-option-selector:eq(1)`).change(() => {
    if (product.options.length === 3) window.Shopify.updateOptionsInSelector(2, parent, product);
    return true;
  });
  $(`${parent} .single-option-selector`).change(() => {
    window.Shopify.updateSwatchAccessibleNames(product, parent);
    return true;
  });
};

// Used for cart functionality
window.htmlEncode = function htmlEncode(value) {
  if (value) {
    return $('<div/>').text(value).html();
  }
  return '';
};

// Check if device is touch-enabled
window.is_touch_device = function is_touch_device() {
  return 'ontouchstart' in window || navigator.maxTouchPoints;
};

// Differentiate between mobile and touch screen laptops
window.touch_device = /Android|webOS|iPhone|iPad|iPod|BlackBerry/i.test(navigator.userAgent);
/******/ })()
;
